// Implements: F-UIX-018, F-IDN-027
/**
 * `/backoffice/people`: Personas (mockup v3 P3). The page only composes: the organization comes
 * from the session's permission answer (`member:update_role`), the list and its writes from the
 * organization module's `PeopleContainer`, keyed by the organization (and by the person, so another
 * person signing in on the same tab never inherits the previous one's screen).
 */

import type { ReactElement } from "react";

import { ByOrganization } from "../../modules/organization/containers/ByOrganization";
import { PeopleContainer } from "../../modules/organization/containers/PeopleContainer";
import { useSession } from "../../shared/api/session";
import { useTranslation } from "../../shared/i18n";
import { PageHeader } from "../../shared/ui/molecules/PageHeader";

export function PeoplePage(): ReactElement | null {
  const { t } = useTranslation();
  const { state } = useSession();
  // `RequireSession` renders this page only for a session; nothing to show otherwise.
  if (state.status !== "authenticated") return null;
  const { user, scopes } = state.view;

  return (
    <section>
      <PageHeader title={t("organization.people.title")} subtitle={t("organization.people.intro")} />
      <ByOrganization key={user.id} scopes={scopes} actions={["member:update_role"]}>
        {(target) => <PeopleContainer organizationId={target.organizationId} currentUserId={user.id} />}
      </ByOrganization>
    </section>
  );
}
